import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(
    private readonly alertController: AlertController,
  ) {
  }

  public async checkForAppUpdate() {
    if (Capacitor.isNativePlatform()) {
      const result = await AppUpdate.getAppUpdateInfo();
      if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
        await this.presentAlert();
      }
    }
  }

  private async presentAlert() {
    const alert = await this.alertController.create({
      header: 'App-Update verfügbar',
      message: 'Es steht eine neue Version unserer App bereit. Um alle Funktionen in vollem Umfang nutzen zu können, empfehlen wir, das Update durchzuführen.',
      buttons: [
        {
          text: 'Jetzt aktualisieren',
          handler: async () => {
            await AppUpdate.openAppStore();
          },
        },
        {
          text: 'Später',
          role: 'cancel',
        },
      ],
    });

    await alert.present();
  }
}
